import axios from "axios";
const baseurl = "https://eats-ezy.herokuapp.com/api";
// const baseurl = "http://localhost:8000";

let token = "";

if (localStorage.getItem("recoil-persist-admin-restro-123")) {
  token = JSON.parse(localStorage.getItem("recoil-persist-admin-restro-123"))
    .auth?.token;
}

const uploadImageApi = async (img) => {
  const formData = new FormData();
  formData.append("upl", img);

  try {
    const res = await axios.post(`${baseurl}/upload-image`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { success: true, data: res.data };
  } catch (e) {
    return { success: false, data: e.response.data.message };
  }
};

export { baseurl, token, uploadImageApi };
